import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Aos from "aos";
import "aos/dist/aos.css";

function ParallaxSection() {
    useEffect(() => {
        Aos.init({
            duration: 800,
            easing: "ease-out-cubic",
            once: true,
        });
    }, []);

    return (
        <div className="relative w-full mt-[106px]">

            {/* ================= FIXED BACKGROUND ================= */}
            <div className="fixed inset-0 -z-10">
                <img
                    src="/assets/our/bg1.jpg"
                    className="w-full h-full object-cover"
                    alt=""
                />
                <div className="absolute inset-0 bg-black/50"></div>
            </div>

            {/* ================= SECTION 1 ================= */}
            <section className="min-h-max lg:pb-[140px] pb-[60px] flex items-center">
                <div className="max-w-[1440px] mx-auto relative h-full w-full lg:px-[70px] px-[20px] flex items-center z-10">
                    <div className="flex items-center lg:flex-row flex-col justify-between w-full">
                        <div
                            className="max-w-[533px] w-full flex flex-col items-start text-center lg:text-left mb-[40px] lg:mb-0"
                            data-aos="fade-right"
                        >
                            <div className='btn-header'>
                                <p>Our work</p>
                            </div>

                            <h6
                                data-aos="fade-up"
                                data-aos-delay="150"
                                className="pb-[0px] lg:pb-[0px] font-neue font-[400] text-[24px] lg:text-[36px] leading-[32px] lg:leading-[45px] text-[#FFFFFF] mt-[10px]"
                            >
                                Ask us about our work.
                            </h6>

                            <p
                                data-aos="fade-up"
                                data-aos-delay="300"
                                className="font-[400] font-neue text-justify text-[14px] lg:text-[16px] leading-[22px] lg:leading-[22px] tracking-[-0.22px] text-[#FFFFFF] mt-[10px]"
                            >
                            We keep client engagements confidential and are glad to discuss relevant experience with prospective clients.
                            </p>

                            <Link to='/contact-us' className="mt-[24px]">
                                <button
                                    className='exp-btn'
                                    data-aos="zoom-in"
                                    data-aos-delay="450"
                                >
                                    Get in touch
                                </button>
                            </Link>
                        </div>

                        <div
                            data-aos="fade-left"
                            data-aos-delay="300"
                            className="max-w-[486px] w-full lg:mr-[40px] rounded-[20px]"
                        >
                            <img
                                src="/assets/home/newlj.png"
                                className="rounded-[20px] h-[220px] lg:h-[340px] w-full object-cover"
                                alt=""
                            />
                        </div>
                    </div>
                </div>
            </section>

            {/* ================= SECTION 2 ================= */}
            {/* <section className="min-h-max lg:pb-[140px] pb-[60px] flex items-center">
                  <div className="max-w-[1440px] mx-auto relative h-full w-full flex items-center px-[20px] lg:px-[70px] z-10">
                    <div className="flex flex-col items-start max-w-[700px]">
                        <div
                            className='btn-header'
                            data-aos="fade-down"
                        >
                            <p>Our Network</p>
                        </div>

                        <h6
                            data-aos="fade-up"
                            data-aos-delay="150"
                            className="pt-[16px] lg:pt-[20px] pb-[5px] lg:pb-[5px] font-neue font-[400] 
                            text-[24px] lg:text-[36px] leading-[34px] lg:leading-[40px] 
                            text-left text-white"
                        >
                            Our work scales through trust and relevance.
                        </h6>

                        <div
                            className="line w-[60px] h-[2px] bg-[#BB872A] mb-[20px]"
                            data-aos="fade-right"
                            data-aos-delay="300"
                        ></div>

                        <p
                            data-aos="fade-up"
                            data-aos-delay="400"
                            className="font-[400] font-neue
                            text-[14px] lg:text-[16px] leading-[22px] lg:leading-[20px] text-justify
                            tracking-[-0.22px] text-white"
                        >
                            Our work depends on trust. We collaborate with partners who match our pace, precision, and principles. Our network spans capital, execution, policy, and domain expertise, activated selectively, challenge by challenge.
                        </p>

                        <Link to='/our-network' className="mt-[24px]">
                            <button
                                className='exp-btn'
                                data-aos="zoom-in"
                                data-aos-delay="550"
                            >
                                Explore More
                            </button>
                        </Link>
                    </div>
                </div>
            </section> */}

            {/* ================= SECTION 3 ================= */}
            {/* <section className="min-h-max lg:pb-[140px] pb-[60px] flex items-center">
                <div className="max-w-[1440px] mx-auto relative h-full w-full flex items-center px-[20px] lg:px-[70px] z-10">
                    <div className="flex flex-col items-start max-w-[700px]">
                        <div
                            className='btn-header'
                            data-aos="fade-down"
                        >
                            <p>Why We Exist</p>
                        </div>

                        <h6
                            data-aos="fade-up"
                            data-aos-delay="150"
                            className="pt-[16px] lg:pt-[20px] pb-[5px] lg:pb-[5px] font-neue font-[400] 
                            text-[24px] lg:text-[36px] leading-[34px] lg:leading-[40px] 
                            text-left text-white"
                        >
                            The corridor doesn't need more noise. It needs more signal.
                        </h6>

                        <div
                            className="line w-[60px] h-[2px] bg-[#BB872A] mb-[20px]"
                            data-aos="fade-right"
                            data-aos-delay="300"
                        ></div>

                        <p
                            data-aos="fade-up"
                            data-aos-delay="400"
                            className="font-[400] font-neue
                            text-[14px] lg:text-[16px] leading-[22px] lg:leading-[20px] text-justify
                            tracking-[-0.22px] text-white"
                        >
                            The U.S.–India relationship has entered a new phase, driven not just by diplomacy or defense deals, but by deep technology, aligned capital, and shared strategic intent.
                            The center of gravity is shifting from statements to systems, from intent to execution.
                            <br /><br />
                            IndUS Tech exists to shorten the distance between intent and execution. IndUS Tech operates in the space between governments and founders, between ambition and action, between policy and product.
                            <br /><br />
                            Our role is to surface signal and translate it into action.
                            Curation enables focus.
                            <b> To align people, capital, and decisions that move the corridor forward.</b>
                        </p>

                        <Link to='/About' className="mt-[24px]">
                            <button
                                className='exp-btn'
                                data-aos="zoom-in"
                                data-aos-delay="550"
                            >
                                Explore More
                            </button>
                        </Link>
                    </div>
                </div>
            </section> */}

        </div>
    );
}

export default ParallaxSection;
